export default __webpack_public_path__ + "static/media/charles-deluvio-GlavtG-umzE-unsplash.2ad62829.jpg";